import {writable} from "svelte/store";

export const jobs = writable([
    {
        id: 7,
        title: 'Software Engineer',
        company: 'Freelancer',
        period: 'August 2022 - Present',
        desc: 'As a freelance software engineer, I work independently to develop, design and maintain software applications. ' +
            'I have experience in a range of programming languages and technologies, ' +
            'allowing me to build customized solutions to meet my clients specific needs. ' +
            'I strive to deliver reliable, scalable and user-friendly software products.'
    },{
        id: 6,
        title: 'Software Developer',
        company: 'Avast',
        period: 'March 2021 - December 2021',
        desc: 'Developing new features, and bug fixing the Omni product\n' +
            '  - Microservice development in Java, Python, and Scala\n' +
            '  - Testing, deploying, and maintaining the app on the AWS\n' +
            'Front-end developer on Avast One product\n' +
            '  - Developing client-side using Javascript and Svelte\n' +
            '  - Bug fixing'
    }, {
        id: 5,
        title: 'Software Developer',
        company: 'Home Credit International',
        period: 'May 2019 - December 2020',
        desc: 'Developing full stack internal web & mobile app for Home Credit field visitors.\n' +
            'Support for production and non production environments.\n' +
            'tech stack: \n' +
            '- BE: Java, Spring, REST, Hibernate, Oracle DB, JMS, RabbitMQ\n' +
            '- FE: TypeScript, React, Redux, Webpack\n' +
            '- other: Docker, Kubernetes, Git, TeamCity, Jira...'
    },
    {
        id: 4,
        title: 'Multimedia Shaper',
        company: 'Young Mountain',
        period: 'December 2018 - April 2019',
        desc: 'Maintaining snowpark facilities and managing the multimedia side of public relations.\n' +
            '- Making and processing digital material such as pictures and videos\n' +
            '- Managing content on social networks'
    },
    {
        id: 3,
        title: 'Software Developer',
        company: 'Siemens',
        period: 'April 2018 - September 2018',
        desc: 'Developing Passenger information system for Siemens trains. \n' +
            'App for passengers and train staff, displaying informations on outside and inside panels.\n' +
            'Tech stack: Java, OSGi, XML, Apache Karaf, Jenkins, SVN, Jira ...'
    }, {
        id: 2,
        title: "Junior Java developer",
        company: "Profinit",
        period: "April 2017 - March 2018 — Prague",
        desc: 'Developing back-end of enterprise applications for financial industry customers. Used technologies: Java JDK 1.8, Spring framework, MyBatis, Database systems - SQL'
    }, {
        id: 1,
        title: "Junior tester",
        company: "Accenture",
        period: "August 2016 - December 2016 — Prague",
        desc: 'Testing SOAP services using SoapUI. Identifying business requirements. Running manual and automated tests. Writing bug reports. Functional testing.'
    }
]);


export const skills = writable([
    {
        type: 'Code - FE',
        skillList: [
            'JavaScript, TypeScript',
            'React, Redux, Svelte',
            'HTML, CSS',
            'Webpack, npm'
        ]
    }, {
        type: 'Code - BE',
        skillList: [
            'Java',
            'SQL, DB systems',
            'Spring, Spring Boot, Hibernate',
            'REST, HTTP, Swagger',
            'Docker, Kubernetes'
        ]
    }, {
        type: 'Personal',
        skillList: [
            'Persistence',
            'Critical Thinking',
            'Adaptability',
            'Patience'
        ]
    }
])


export const education = writable([
    {
        school: 'Czech Technical University in Prague',
        major: 'Software Engineering',
        period: '2013 - 2017',
        courses: [
            ['Database Systems','Design of SW Systems','Software Testing','Data Networks'],
            ['Principles of Mobile Apps','Foundation of Web Apps','Client Apps in Javascript','Enterprise Applications',]
        ]
    }, {
        school: 'High School of Electrical Engineering, Slovakia',
        major: 'Electrical Engineering & computer science',
        period: '2009 - 2013',
        courses: [
            ['Cisco Academy','Programming Fundamentals','Circuit Theory','Automation'],
            ['Physics','Math','Electronics','Multimedia Processing']
        ]
    }
])
